import {StyleSheet} from "react-native";
import { styleVars} from "../../app-style-vars";

export default StyleSheet.create({

  fixedHeaderContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    width: '100%',
    zIndex: 1,
    paddingTop: styleVars.statusBarHeight(),
  },


  headerContainer: {
    width: '100%',
    backgroundColor: '#fff',
  },
  logoRow: {
    minHeight: styleVars.headerLogoSectionHeight,
    paddingLeft: styleVars.headerLogoWidth + styleVars.rem(2),
    height: styleVars.headerLogoSectionHeight,
    overflow: 'hidden',
  },
  logoContainer: {
    width: styleVars.headerLogoWidth + styleVars.rem(1.5),
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
  },
  logoWrapper: {
    flex:1,
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  logo: {
    width: styleVars.headerLogoWidth,
    height: styleVars.headerLogoHeight,
    resizeMode: 'contain'
  },
  siteTitleContainer: {
    paddingHorizontal: styleVars.rem(.75),
    paddingVertical: styleVars.rem(.5),
  },
  headerInnerContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: styleVars.headerFixedSectionHeight - styleVars.rem(.5),  /** subtract supergraphic height */
    minHeight: styleVars.headerFixedSectionHeight - styleVars.rem(.5),  /** subtract supergraphic height */
  },
  headerLeftAreaContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  headerTitleContainer: {
    paddingLeft: styleVars.rem(1),
    paddingRight: styleVars.rem(1),
  },
  headerTitle: {
    textAlign: 'left',
    color: styleVars.boschDarkBlue,
    fontWeight: 'bold',
    fontSize: styleVars.rem(1),
  },
  headerRightAreaContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  headerIconContainer: {
    paddingLeft: styleVars.rem(.75),
    paddingRight: styleVars.rem(.75),
    paddingTop: styleVars.rem(.75),
    paddingBottom: styleVars.rem(.75),
  },
  superGraphic: {
    width: '100%',
    height: styleVars.rem(0.5),
  },
  headerMenuFlyoutContainer: {
    backgroundColor: styleVars.boschLightGrayW75,
    borderWidth: 1,
    borderColor: styleVars.boschLightGray,
  },
  headerMenuFlyoutContentWrapper: {
    padding: styleVars.rem(1),
  }
})
